
// COMPONENTS
import events_component from './admin/events_component.js';
import branches_component from './admin/branches_component.js';
import companies_component from './admin/companies_component.js';
import contract_type_component from './admin/contract_type_component.js';
import termination_reason_component from './admin/termination_reason_component.js';
import departments_component from './admin/departments_component.js';
import employee_fields_component from './admin/employee_fields_component.js';
import features_roles_component from './admin/features_roles_component.js';
import holidays_component from './admin/holidays_component.js';
import leave_categories_component from './admin/leave_categories_component.js';
import leave_types_component from './admin/leave_types_component.js';

import employee_view_bursaries_component from './employee/employee_view_bursaries_component.js';
import employee_view_document_component from './employee/employee_view_document_component.js';
import employee_view_remuneration_component from './employee/employee_view_remuneration_component.js';
import employee_view_employment_component from './employee/employee_view_employment_component.js';
import employee_view_general_component from './employee/employee_view_general_component.js';
import employee_view_history_component from './employee/employee_view_history_component.js';
import employee_view_leave_component from './employee/employee_view_leave_component.js';
import employee_view_management_component from './employee/employee_view_management_component.js';
import employee_view_notes_component from './employee/employee_view_notes_component.js';
import employee_view_search_component from './employee/employee_view_search_component.js';
import employee_view_systems_component from './employee/employee_view_systems_component.js';
import employee_view_performance_management from './employee/employee_view_performance_management.js';
import employee_view_disciplinary_component from './employee/employee_view_disciplinary_component.js';

import language_phrase_component from './language_phrase/language_phrase_component.js';

// Search components
import department_search_component from './search/department_search_component.js';
import company_search_component from './search/company_search_component.js';
import managed_department_search_component from './search/managed_department_search_component.js';
import employee_search_component from './search/employee_search_component.js';
import manager_search_component from './search/manager_search_component.js';
import cycle_search_component from './search/performance_cycle_search.js';
import rating_method_search_component from './search/rating_method_search.js';

// ui-ps pagination component
import data_pagination from './data_pagination/index.js';

// ui-ps navbar
import navbar from './navbar/ps_navbar.js';

// ui-ps checkbox dropdwn
import checkbox_dropdown from './checkbox_dropdown/checkbox_dropdown.js';

// custom checkbox dropdown
import checkbox_dropdown2 from './checkbox_dropdown_rules/checkbox_dropdown2.js';

export default [
	events_component,
	companies_component,
	contract_type_component,
	termination_reason_component,
	branches_component,
	departments_component,
	employee_fields_component,
	employee_view_bursaries_component,
	employee_view_document_component,
	employee_view_remuneration_component,
	employee_view_employment_component,
	employee_view_general_component,
	employee_view_history_component,
	employee_view_leave_component,
	employee_view_management_component,
	employee_view_notes_component,
	employee_view_search_component,
	employee_view_systems_component,
	employee_view_performance_management,
	employee_view_disciplinary_component,
	features_roles_component,
	holidays_component,
	language_phrase_component,
	leave_categories_component,
	leave_types_component,
	department_search_component,
	company_search_component,
	managed_department_search_component,
	employee_search_component,
	manager_search_component,
	cycle_search_component,
	data_pagination,
	navbar,
	checkbox_dropdown,
	checkbox_dropdown2,
	rating_method_search_component
];
